document.addEventListener('DOMContentLoaded', () => {
  console.log('[EV-SUGGEST] script loaded (multi-modal support)');

  // ヘッダー内の検索モーダルを全部拾う（PC用・SP用どちらも）
  const searchWrappers = document.querySelectorAll('.header__search');
  if (!searchWrappers.length) {
    console.warn('[EV-SUGGEST] .header__search not found');
    return;
  }

  // ------- 共通のプロダクトキャッシュ -------

  let allProducts = null;
  let isLoadingProducts = false;

  // ✅ 追加：隠したいタグ（検索候補から除外）
  const HIDE_TAG = 'line_sale';

  // ✅ 追加：products.json の tags を判定（文字列/配列どちらでも対応）
  function hasHideTag(raw) {
    const t = raw && raw.tags;
    if (!t) return false;

    // products.json の tags は「"tag1, tag2"」の文字列が多い
    if (typeof t === 'string') {
      return t
        .toLowerCase()
        .split(',')
        .map((s) => s.trim())
        .includes(HIDE_TAG);
    }

    // 念のため配列にも対応
    if (Array.isArray(t)) {
      return t.map((s) => String(s).toLowerCase().trim()).includes(HIDE_TAG);
    }

    return false;
  }

  // 文字列などを数値価格に揃える
  function normalizePrice(value) {
    if (value == null) return null;

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value === 'string') {
      // "10000.00" や "¥10,000" などを数値化
      const digits = value.replace(/[^\d.]/g, '');
      if (!digits) return null;
      const num = Number(digits);
      return Number.isFinite(num) ? num : null;
    }

    return null;
  }

  function buildProductObject(p) {
    const variants = Array.isArray(p.variants) ? p.variants : [];
    const firstVariant = variants[0] || null;

    const imageSrc =
      p.images && p.images[0]
        ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src)
        : null;

    const priceNum = firstVariant ? normalizePrice(firstVariant.price) : null;
    const compareNum = firstVariant
      ? normalizePrice(firstVariant.compare_at_price)
      : null;

    // 🔍 在庫判定：全バリアントのどれか1つでも在庫があれば「在庫あり」
    let isAvailable = true;

    if (variants.length) {
      isAvailable = variants.some((v) => {
        if (typeof v.available === 'boolean') {
          return v.available;
        }

        if (v.inventory_management == null) {
          return true;
        }

        const qty =
          typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0;
        return qty > 0;
      });
    }

    return {
      title: p.title,
      url: '/products/' + p.handle,
      image: imageSrc,
      price: priceNum,
      compare_at_price: compareNum,
      available: isAvailable
    };
  }

  // 単価 or productオブジェクトから表示用の「¥xx,xxx」文字列を返す
  function getDisplayPrice(valueOrProduct) {
    let val = valueOrProduct;

    if (
      typeof valueOrProduct === 'object' &&
      valueOrProduct !== null &&
      'price' in valueOrProduct
    ) {
      val = valueOrProduct.price;
    }

    if (val == null) return '';

    if (typeof val === 'number') {
      if (val === 0) return '';
      return '¥' + Math.round(val).toLocaleString('ja-JP');
    }

    if (typeof val === 'string') {
      const digits = val.replace(/[^\d]/g, '');
      if (!digits || Number(digits) === 0) return '';
      return val;
    }

    return '';
  }

  // セール／通常で価格レイアウトを組み立てる
  function buildPriceHtml(item) {
    const price = item.price;
    const compare = item.compare_at_price;

    const priceText = getDisplayPrice(price);
    const compareText = compare != null ? getDisplayPrice(compare) : '';

    // セール（compare > price）のとき
    if (compare != null && compare > price && compareText && priceText) {
      return (
        '<div class="ev-suggest__price-wrap ev-suggest__price-wrap--sale">' +
          '<span class="ev-suggest__price-now">' + priceText + '</span>' +
          '<span class="ev-suggest__price-compare">' + compareText + '</span>' +
        '</div>'
      );
    }

    // 通常価格のみ
    if (priceText) {
      return (
        '<div class="ev-suggest__price-wrap">' +
          '<span class="ev-suggest__price">' + priceText + '</span>' +
        '</div>'
      );
    }

    return '';
  }

  // マッチした商品リストを返す（タイトル＋商品説明も検索対象）
  function filterProducts(term) {
    if (!allProducts || allProducts.length === 0) return [];

    const q = term.toLowerCase().trim();
    if (!q) return [];

    console.log('[EV-SUGGEST] filtering for:', q);

    const matches = allProducts
      // まず「タイトル or 説明文」にキーワードが入っている product だけ絞り込む
      .filter((raw) => {
        // ✅ 追加：隠しタグの商品は候補から除外
        if (hasHideTag(raw)) return false;

        const title = (raw.title || '').toLowerCase();

        // body_html / body から HTML タグをざっくり除去してテキストだけにする
        const bodyHtml = (raw.body_html || raw.body || '').toLowerCase();
        const bodyText = bodyHtml.replace(/<[^>]*>/g, ' ');

        // タイトルか説明文のどちらかに q が含まれていればヒット
        return title.includes(q) || bodyText.includes(q);
      })
      // そのあと、表示用オブジェクトに変換
      .map((raw) => buildProductObject(raw))
      // 並び順：タイトル先頭マッチ優先 → タイトルの辞書順
      .sort((a, b) => {
        const ta = (a.title || '').toLowerCase();
        const tb = (b.title || '').toLowerCase();

        const aStarts = ta.startsWith(q);
        const bStarts = tb.startsWith(q);

        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;

        return ta.localeCompare(tb);
      });

    console.log(
      '[EV-SUGGEST] matched count:',
      matches.length,
      'examples:',
      matches.slice(0, 3).map((m) => m.title)
    );

    // ここでは少し多めに返しておいて、表示数は render 側で制御
    return matches.slice(0, 30);
  }

  async function loadAllProductsOnce() {
    if (allProducts) return allProducts;
    if (isLoadingProducts) {
      await new Promise((resolve) => setTimeout(resolve, 200));
      return allProducts || [];
    }

    isLoadingProducts = true;
    try {
      const root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        '/';

      const url = `${root}products.json?limit=250`;
      console.log('[EV-SUGGEST] load products:', url);

      const res = await fetch(url, {
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) {
        console.warn('[EV-SUGGEST] products.json response not ok', res.status);
        allProducts = [];
        return allProducts;
      }

      const data = await res.json();
      allProducts = data.products || [];
      console.log('[EV-SUGGEST] products loaded:', allProducts.length);
      return allProducts;
    } catch (e) {
      console.error('[EV-SUGGEST] load products error:', e);
      allProducts = [];
      return allProducts;
    } finally {
      isLoadingProducts = false;
    }
  }

  // ------- 各検索モーダルごとに初期化 -------
  searchWrappers.forEach((wrapper, idx) => {
    const input = wrapper.querySelector('[data-ev-suggest-input="header"]');
    const container = wrapper.querySelector('[data-ev-suggest]');
    const resultsBox = container
      ? container.querySelector('[data-ev-suggest-results]')
      : null;

    // ★ 下部固定ボタン（Liquid で書いたほう）
    const viewAllFixed = wrapper.querySelector('[data-ev-suggest-view-all]');

    if (!input || !container || !resultsBox) {
      console.warn('[EV-SUGGEST] missing elements in wrapper', idx);
      return;
    }

    // ★ この wrapper の <details>（検索モーダル本体）を取得
    const detailsEl = wrapper.querySelector('details');
    if (detailsEl && !detailsEl.dataset.evSearchBound) {
      detailsEl.dataset.evSearchBound = 'true';

      detailsEl.addEventListener('toggle', () => {
        const isOpen = detailsEl.open;

        // 背景スクロール制御用クラス
        document.documentElement.classList.toggle('ev-search-open', isOpen);
        document.body.classList.toggle('ev-search-open', isOpen);

        if (isOpen) {
          // 🔹 モーダルを開いたタイミングで前回の結果を消す
          if (resultsBox) {
            resultsBox.innerHTML = '';
          }
          if (container) {
            container.hidden = true;
          }
          if (input) {
            input.value = '';
            input.setAttribute('aria-expanded', 'false');
          }
          lastTerm = '';
        } else {
          // 🔹 閉じるときも念のためクリア
          clearSuggestions();
          lastTerm = '';
          if (input) {
            input.value = '';
          }
        }
      });
    }

    console.log(`[EV-SUGGEST] init wrapper #${idx}`);

    let debounceTimer = null;
    let lastTerm = '';

    function clearSuggestions() {
      resultsBox.innerHTML = '';
      container.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      // ボタンの href は特にリセットしなくてOK
    }

    // 🔽 ここが一番大事：リストだけ描画して、ボタンは既存のものを使う
    function renderSuggestions(products, term) {
      if (!products || products.length === 0) {
        clearSuggestions();
        return;
      }

      const available = [];
      const soldOut = [];

      products.forEach((p) => {
        const hasBoolAvailable = typeof p.available === 'boolean';

        const priceVal = p.price;
        const isPriceEmpty =
          priceVal === null ||
          priceVal === undefined ||
          priceVal === 0 ||
          priceVal === '0';

        const isSoldOut =
          (hasBoolAvailable && !p.available) ||
          isPriceEmpty;

        if (isSoldOut) {
          soldOut.push(p);
        } else {
          available.push(p);
        }
      });

      if (!available.length && !soldOut.length) {
        clearSuggestions();
        return;
      }

      const MAX_RESULTS = 10;
      const availToShow = available.slice(0, MAX_RESULTS);
      const remainForSold = Math.max(0, MAX_RESULTS - availToShow.length);
      const soldToShow = soldOut.slice(0, remainForSold);

      function itemHtml(p, isSoldOut) {
        const priceHtml = !isSoldOut ? buildPriceHtml(p) : '';
        const image =
          p.image ||
          p.featured_image ||
          (p.featured_media &&
            p.featured_media.preview_image &&
            p.featured_media.preview_image.src) ||
          (p.images && p.images[0]);

        return `
          <li class="ev-suggest__item ${
            isSoldOut ? 'ev-suggest__item--soldout' : ''
          }">
            <a href="${p.url || p.url_to || '#'}" class="ev-suggest__link">
              ${
                image
                  ? `
                <div class="ev-suggest__thumb">
                  <img src="${image}" alt="${(p.title || '')
                    .replace(/"/g, '&quot;')}">
                  ${
                    isSoldOut
                      ? '<span class="ev-suggest__thumb-overlay"></span>'
                      : ''
                  }
                </div>
              `
                  : ''
              }
              <div class="ev-suggest__meta">
                <div class="ev-suggest__title">${p.title || ''}</div>
                ${
                  isSoldOut
                    ? `<span class="ev-suggest__badge">SOLD OUT</span>`
                    : priceHtml
                }
              </div>
            </a>
          </li>
        `;
      }

      let html = '';

      if (availToShow.length) {
        html += `
          <section class="ev-suggest__section ev-suggest__section--available">
            <h3 class="ev-suggest__heading">IN STOCK</h3>
            <ul class="ev-suggest__list" role="listbox">
              ${availToShow.map((p) => itemHtml(p, false)).join('')}
            </ul>
          </section>
        `;
      }

      if (soldToShow.length) {
        html += `
          <section class="ev-suggest__section ev-suggest__section--soldout">
            <h3 class="ev-suggest__heading">SOLD OUT / ARCHIVE</h3>
            <ul class="ev-suggest__list" role="listbox">
              ${soldToShow.map((p) => itemHtml(p, true)).join('')}
            </ul>
          </section>
        `;
      }

      // ★ ここで「全ての検索結果を見る」ボタンは生成しない！
      resultsBox.innerHTML = html;

      // ★ 代わりに、下部固定ボタンの href だけ更新
      if (viewAllFixed) {
        viewAllFixed.href = `/search?q=${encodeURIComponent(term)}`;
        viewAllFixed.style.display = 'block';
      }

      container.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    async function fetchSuggestions(term) {
      const q = term.trim();
      if (!q) {
        clearSuggestions();
        return;
      }
      if (q === lastTerm) return;
      lastTerm = q;

      await loadAllProductsOnce();
      const matched = filterProducts(q);
      renderSuggestions(matched, q);
    }

    function handleInput(event) {
      const value = event.target.value;
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchSuggestions(value);
      }, 250);
    }

    input.addEventListener('input', handleInput);

    // 既に候補があればフォーカス時に再表示
    input.addEventListener('focus', () => {
      if (resultsBox.innerHTML.trim() !== '') {
        container.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    // blur: PCだけ消す。SP（pointer: coarse）は残す
    input.addEventListener('blur', () => {
      try {
        if (
          window.matchMedia &&
          window.matchMedia('(pointer: coarse)').matches
        ) {
          return;
        }
      } catch (e) {}
      setTimeout(() => {
        clearSuggestions();
      }, 200);
    });

    // ESC で閉じる
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        clearSuggestions();
      }
    });
  });
});
